import { Link } from 'react-router-dom';

const facts = [
  { label: '剧集名称', value: '我的朋友他的妻子' },
  { label: '类型', value: '都市情感 · 悬疑' },
  { label: '集数', value: '共 12 集' },
  { label: '首播', value: '2025 年 3 月' },
  { label: '主要场景', value: '旧城酒吧 / 公寓 / 南岸海边' },
  { label: '叙事结构', value: '现在线与回忆线交叉' },
];

export default function SeriesProfile() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-14">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[280px_1fr] lg:gap-14">
        <div className="mx-auto w-full max-w-[280px] lg:mx-0">
          <div className="relative overflow-hidden rounded-lg border border-background-200/80 bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Cinematic%20vertical%20movie%20poster%20key%20art%20of%20two%20figures%20standing%20apart%20in%20heavy%20rain%20on%20an%20old%20city%20street%20at%20night%2C%20warm%20amber%20streetlamp%20glow%20cutting%20through%20fog%2C%20wet%20reflective%20pavement%2C%20deep%20charcoal%20silhouettes%2C%20strong%20negative%20space%20above%2C%20dramatic%20moody%20lighting%2C%20film%20grain%2C%20premium%20arthouse%20poster%20composition&width=800&height=1200&seq=series-keyart-01&orientation=portrait"
              alt="剧集《我的朋友他的妻子》竖版主海报"
              title="我的朋友他的妻子 - 剧集主海报"
              className="aspect-[2/3] w-full object-cover object-top"
            />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-background-50 via-background-50/70 to-transparent p-4 pt-14">
              <p className="font-heading text-sm font-bold tracking-wide text-foreground-950">
                我的朋友他的妻子
              </p>
              <p className="mt-1 font-label text-[10px] tracking-[0.3em] text-primary-400">
                2025 · 12 EPISODES
              </p>
            </div>
            <span className="absolute left-3 top-3 rounded-full border border-primary-500/40 bg-background-50/80 px-2.5 py-0.5 text-[10px] text-primary-300 backdrop-blur">
              主视觉
            </span>
          </div>
        </div>

        <div>
          <div className="flex items-center gap-3">
            <span className="h-px w-8 bg-primary-500"></span>
            <span className="font-label text-xs tracking-[0.3em] text-primary-400">SERIES FILE</span>
          </div>
          <h2 className="mt-3 max-w-2xl font-heading text-xl font-bold leading-snug text-foreground-950 md:text-3xl">
            三个都不肯先开口的人，构成了这部剧全部的张力和遗憾
          </h2>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-400 md:text-base">
            陈默拍纪录片，习惯躲在镜头后面；江暖守着旧城的酒吧，把体面当成盔甲；陆嘉行是那个先低头收拾残局的人。三个人在同一张桌子上吃了很多顿饭，却始终没有把最该说的那句话说完。
          </p>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-500">
            剧集用十二集、两条时间线和一间只有三面墙的酒吧，把这个关于"错过"的故事慢慢摊开。这里整理了它的完整脉络，也记录下那些藏在细节里的东西。
          </p>

          <dl className="mt-7 grid grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-2">
            {facts.map((fact) => (
              <div
                key={fact.label}
                className="flex items-baseline gap-3 border-b border-background-200/60 pb-2.5"
              >
                <dt className="shrink-0 text-xs text-foreground-500">{fact.label}</dt>
                <dd className="text-sm text-foreground-200">{fact.value}</dd>
              </div>
            ))}
          </dl>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/story"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-400"
            >
              <i className="ri-book-open-line"></i>
              阅读剧情脉络
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 px-5 py-2.5 text-sm text-foreground-300 transition-colors hover:border-primary-500/50 hover:text-primary-300"
            >
              <i className="ri-information-line"></i>
              了解本站内容
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}